import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate, useOutlet } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { LOGIN, NON_REVARC_DASHBOARD, PROFILES } from 'src/constants/routeName';
import Header from './Header';
import NavBar from './NavBar';
import { decryptResponse } from 'src/components/common/EncryptDecrypt';
import { keepAliveApi } from 'src/context/actions/dashboard';
import Swal from 'sweetalert2';



const ProtectedRoute = ({ heading, sync }) => {

    const outlet = useOutlet();
    
 const user = decryptResponse(reactLocalStorage.getObject('user', {}));
 

    return (
        (
           !( user?.is_superuser || user?.is_admin_supervisor) ?
                <Navigate to={'/unauthorized'} replace />
                : outlet
                
        )

    )
}

export default ProtectedRoute
